export const DEBUG =
  process.env.DEBUG?.toLocaleLowerCase() === "true" ||
  process.env.NODE_ENV !== "production" ||
  false;

export const PARKING_API_ENDPOINT =
  process.env.REACT_APP_PARKING_API_ENDPOINT || undefined;
